import React from "react";
import { EvtStatsCard as StatsCard } from "components/stats/display-card";
import { EvtStatsCardLoader } from "components/stats/loader";
import { DisplayAmount } from "components/display/amount";
import { useTotalBillableStats } from "../hooks/useTotalBillableStats";

export function TotalBillableCard({ dateRange, info }) {
    const { data: stats, isLoading, error } = useTotalBillableStats(dateRange);



    if (isLoading) {
        return <EvtStatsCardLoader />;
    }

    if (error) {
        return (
            <StatsCard
                label="Total"
                value="Error loading data"
                className="text-red-500"
            />
        );
    }

    const totalAmount = stats?.totalAmount || 0;

    return (
        <StatsCard
            label="Total"
            value={<DisplayAmount value={totalAmount} />}
            info={info}
        />
    );
}
